export const LINKS = [
  { key: "about", title: "me me me me" },
  {
    key: "projects",
    title: "you don't need to check them out. just hire me. you wont regret"
  },
  {
    key: "blog posts",
    title:
      "if you have the time and attention span, i dare you to read them and respond"
  }
];

export const PROFESSIONAL_EXPERIENCE = [
  {
    title: "Software Engineer",
    companies: [
      {
        name: "Rootly",
        skills:
          "Ruby on Rails, Turbo, Hotwire, Stimulus, PostgreSQL, Claude AI",
        yearStart: 2024
      },
      {
        name: "Neeto",
        skills: "Ruby on Rails, ReactJS, Kubernetes, Docker, AWS, Heroku",
        yearEnd: 2024,
        yearStart: 2021
      }
    ]
  },
  {
    title: "Cybersecurity Analyst",
    companies: [
      {
        name: "EY",
        skills: "Pen Testing, Burp Suite, Qualys",
        yearEnd: 2021,
        yearStart: 2020
      }
    ]
  }
];
